/**
 * This is the entry point for Feature Hub App integration
 */

import React from 'react';
import { FeatureAppDefinition, FeatureAppEnvironment, FeatureServices } from '@feature-hub/core';
import { ReactFeatureApp } from '@feature-hub/react';
import { Provider as StoreProvider } from 'react-redux';
import type { Logger } from '@feature-hub/logger';
import { ThemeProvider } from '@oneaudi/unified-web-common';
import type { GfaLocaleServiceV1 } from '@volkswagen-onehub/gfa-locale-service';
import { GfaServiceConfigProviderV1 } from '@volkswagen-onehub/gfa-service-config-provider';
import type { ContentServiceV1 as ContentService } from '@volkswagen-onehub/audi-content-service';
import { DealerContextServiceV1 } from '@oneaudi/dealer-context-service';
import App from './FeatureApp';
import { store } from './reducers';

// import {
//   defineOneGraphService,
//   OneGraphFeatureService,
// } from '../feature-services/onegraph-feature-service';
// import { defineOneGraphService } from '../feature-services/onegraph-feature-service';

export interface FeatureServiceDependencies extends FeatureServices {
  readonly 's2:logger'?: Logger;
  readonly 'gfa:service-config-provider': GfaServiceConfigProviderV1;
  readonly 'audi-content-service'?: ContentService;
  readonly 'gfa:locale-service': GfaLocaleServiceV1;
  readonly 'dealer-context-service': DealerContextServiceV1;
  // readonly 'dbad:onegraph-service': OneGraphFeatureService;
}

const normalizeConfig = (config: any) => {
  if (config?.__type === 'aem-headless') {
    return config?.config?.fields;
  }

  return config;
};

const featureAppDefinition: FeatureAppDefinition<ReactFeatureApp, FeatureServiceDependencies> = {
  /* ownFeatureServiceDefinitions: [
    defineOneGraphService({
      endpoint: process.env.ONEGRAPH_ENDPOINT ?? '',
      apikey: process.env.ONEGRAPH_APIKEY ?? '',
    }),
  ],
  */

  dependencies: {
    featureServices: {
      's2:logger': '^1.0.0',
      'gfa:locale-service': '^1.0.0',
      'dealer-context-service': '^1.0.0',
      // TODO 'dbad:onegraph-service': '^1.0.0',
    },
    externals: {
      react: '*',
      'styled-components': '*',
      // '@volkswagen-onehub/onegraph-client': '*',
    },
  },
  optionalDependencies: {
    featureServices: {
      'audi-content-service': '^1.0.0',
    },
  },

  create: ({
    featureServices,
    config: remoteConfig,
  }: FeatureAppEnvironment<FeatureServiceDependencies, void>) => {
    const loggerService = featureServices['s2:logger'];
    const dealerContextService = featureServices['dealer-context-service'];
    const contentService = featureServices['audi-content-service'];
    loggerService?.info('Feature App created.');

    const configProvider = featureServices[
      'gfa:service-config-provider'
    ] as GfaServiceConfigProviderV1;

    // const oneGraphClient = featureServices['dbad:onegraph-service'].getOneGraphClient();

    const normalConfig = normalizeConfig(remoteConfig);

    return {
      render: () => {
        return (
          <ThemeProvider>
            <StoreProvider store={store}>
              <App
                configProvider={configProvider}
                dealerContextService={dealerContextService}
                contentService={contentService}
                remoteConfig={normalConfig}
              />
            </StoreProvider>
          </ThemeProvider>
        );
      },
    };
  },
};

export default featureAppDefinition;
